import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-egi-breadcrumb',
  templateUrl: './egi-breadcrumb.component.html',
  styleUrls: ['./egi-breadcrumb.component.scss'],
})
export class EgiBreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.buildBreadcrumbs(this.route.root);
      });
  }
  buildBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Array<{ label: string; url: string }> = [],
  ): Array<{ label: string; url: string }> {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) return breadcrumbs;

    for (const child of children) {
      const routeURL = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');

      // Build URL with param substitution
      const routeParams = child.snapshot.params;
      const pathWithParams = child.routeConfig?.path
        ?.split('/')
        .map((segment) => {
          if (segment.startsWith(':')) {
            const paramName = segment.slice(1);
            return routeParams[paramName];
          }
          return segment;
        })
        .join('/');

      if (pathWithParams) {
        url += `/${pathWithParams}`;
      }

      // Replace breadcrumb label if it's a param placeholder (e.g. ':accountNum')
      let label = child.snapshot.data['breadcrumb'];
      if (typeof label === 'string' && label.startsWith(':')) {
        const paramName = label.slice(1);
        label = routeParams[paramName];
      }

      console.log(
        'Route segment:',
        child.snapshot.url.map((s) => s.path).join('/'),
      );
      console.log('Current URL:', url);
      console.log('Breadcrumb label:', label);

      if (typeof label === 'string') {
        breadcrumbs.push({ label, url });
      }
      return this.buildBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
